<template>
  <h2 class="page-sub-header">Construction Code AI Assistant - Help Center</h2>
  <p>Need assistance? You’re in the right place! Below, you’ll find answers to common questions about using Construction
    Code AI Assistant, managing your subscription, and getting the most out of the app.</p>

  <!--SECTION 1  -->
  <div class="section">

    <h3 class="section-header">Getting Started</h3>

    <p class="section-primary-point">How do I create an account?</p>
    <ul>
      <li>Tap <strong>Sign Up</strong> and enter your email and password.</li>
      <li>Check your inbox for a verification email.</li>
      <li>Once verified, log in and start exploring!</li>
    </ul>

    <p class="section-primary-point">How does the free trial work?</p>
    <ul>
      <li>Each plan has a 3 day free trial to determine if Construction Code AI Assistant is right for you.</li>
      <li>After the trial, you’ll be automatically subscribed to the plan you selected.</li>
      <li>Cancel anytime during the trial to avoid charges.</li>
    </ul>
  </div>

  <!-- SECTION 2 -->
  <div class="section">

    <h3 class="section-header">Subscription & Billing</h3>

    <p class="section-primary-point">What subscription plans are available?</p>
    <ul>
      <li>1 Credit: $4.99/month</li>
      <li>3 Credits: $9.99/month</li>
      <li>5 Credits: $14.99/month</li>
      <li>7 Credits: $19.99/month</li>
      <li>Unlimited: $49.99/month</li>
    </ul>

    <p class="section-primary-point">How do credits work?</p>
    <ul>
      <li>Each National, State or Regional Code costs <strong>1 credit</strong>.</li>
      <li>Credits can be used across multiple conversations.</li>
      <li>Deleting a conversation restores credits (may take 2-3 minutes).</li>
    </ul>
  </div>

  <!--  SECTION 3 -->
  <div class="section">
    <h3 class="section-header">Using the App</h3>

    <p class="section-primary-point">What kind of code data does the app provide?</p>
    <p>Building, electrical, plumbing, fire, and accessibility codes.</p>

    <p class="section-primary-point">How accurate is the AI?</p>
    <p>AI is trained on real code documentation, but verify with local authorities.</p>

  </div>

  <!--  SECTION 4 -->
  <div class="section">
    <h3 class="section-header">Account & Privacy</h3>
    <p class="section-primary-point">How do I reset my password?</p>
    <p>On the login screen, tap <strong>Forgot Password?</strong></p>

<!--
    <p class="section-primary-point">Can I delete my account?</p>
    <p>Yes, go to <strong>Profile > Request Account Deletion</strong>.</p>
    <p><strong>Warning:</strong> This permanently deletes your account and all data.</p>
-->

  </div>

  <!--  SECTION 5 -->
</template>

<script>
export default {
  name: "CodeAuthorityHelp",
};
</script>
